import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { IconsServiceDefinition } from './icons-service-definition';
import { Observable } from 'rxjs';

@Injectable()
export class NxiIconService  {
    private serviceUrl: string;
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
        logService.info('IconsService : constructor Initializing');
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(IconsServiceDefinition.getInstance());
    }

    public getMessages():  Observable<any> {
        return this.http.get(this.serviceUrl + '/portfolio/messages');
    }
    
    public isOneClickEdelEnabled(): Observable<any> {
        let timeNow = Date.now();
        let goPaperless = true;
        return this.http.get(this.serviceUrl + '/portfolio/show-oneclick-edel' + '?isGoPaperlessRequest=' + goPaperless + '&time=' + timeNow, {responseType: 'json' });
    }
}
